import React, { useEffect, useState } from 'react';
import { Col, Row, Form, message, Button, Typography } from "./../../ui/ot";
import axios from 'axios';
import { StaffForm } from './../personal_information_management'
import { useCRUDController } from "../../ui/classify_structure/CRUDController";


const Home = () => {
    const [activeTabKey, setActiveTabKey] = useState('CompanyJobInformation');
    const onTabChange = (key) => {
        setActiveTabKey(key);
    };
    const [form] = Form.useForm();
    const [checkStrictly, setCheckStrictly] = useState(false);
    const [formReloadCount, setFormReloadCount] = useState(0)
    const [axiosMode, setAxiosMode] = useState("patch")
    const [modalLoading, setModalLoading] = useState(false)

    const onFinish = ({ axiosMode, status, values }) => {
        if (status === "success") {
            if (axiosMode === "post") {
                message.success("新增成功")
            }
            else if (axiosMode === "patch") {
                message.success("修改成功")
            }
            else if (axiosMode === "delete") {
                message.success("刪除成功")
            }
            setModalLoading(false)
        }
        else {
            if (axiosMode === "post") {
                message.error("新增失敗")
            }
            else if (axiosMode === "patch") {
                message.error("修改失敗")
            }
            else if (axiosMode === "delete") {
                message.error("刪除失敗")
            }
            setModalLoading(false)
        }
    }
    const onBefore = ({ axiosMode, status, values }) => {
        setModalLoading(true)
    }

    const personalInformationController = useCRUDController({ onBefore, onFinish, apiRoute: "/organization_structure/api/staff_self" });
    const staffController = useCRUDController({ onBefore, onFinish, apiRoute: "/organization_structure/api/staff" });
    const departmentController = useCRUDController({ onBefore, onFinish, apiRoute: "/organization_structure/api/department" });
    const roleController = useCRUDController({ onBefore, onFinish, apiRoute: "/organization_structure/api/role" });

    const changeDepartmentRole = (departmentRoleDataTemp) => {
        let departmentRoleDataResult = []
        departmentRoleDataResult = departmentRoleDataTemp.map((item, index) => {
            let departmentId = 0
            let roleId = 0

            departmentController.ResponseData.map((departmentDataItem, i) => {
                if (departmentDataItem.classify_structure_type_id === item.department_classify_structure_type_id) {
                    departmentId = departmentDataItem.department_id
                    roleController.ResponseData.map((roleDataItem, ii) => {
                        if (roleDataItem.classify_structure_type_id === item.role_classify_structure_type_id) {
                            roleId = roleDataItem.role_id
                        }
                    })
                }
            })
            return (
                {
                    department_id: departmentId,
                    role_id: roleId
                }
            )
        })
        return departmentRoleDataResult;
    }
    const onFormFinish = () => {
        const values = form.getFieldsValue()
        let departmentRoleData = []
        if (values.user_department_role_data) {
            departmentRoleData = changeDepartmentRole(values.user_department_role_data)
        }

        let datas = [{
            ...values,
            "user_language_data": departmentRoleData
        }]
        if (axiosMode === "post") {
            staffController.postData(datas)
        } else if (axiosMode === "patch") {
            staffController.patchData(datas)
        }
    };

    useEffect(() => {
        departmentController.getData()
        roleController.getData()
        getQrcodeBind()
        personalInformationController.getData()
    }, [])

    useEffect(() => {
        if (personalInformationController.ResponseData) {
            const personalData = personalInformationController.ResponseData?.find(_ => true)
            if (!Array.isArray(personalData) && personalData) {
                form.setFieldsValue(personalData)
            }
        }
    }, [personalInformationController.ResponseData])

    useEffect(() => {
        if (checkStrictly) {
            form.setFieldValue('old_password', "")
            form.setFieldValue('password', "")
            form.setFieldValue('password1', "")
        }
    }, [checkStrictly])
    const getQrcodeBind = () => {
        axios
            .get('/qrcode/bind')
            .then(response => {
                if (response.data.status !== 'success' && localStorage.getItem("lineBind") === "true") {
                    localStorage.setItem("lineBind", false)
                }
            })
    }
    return (
        <>
            <Row gutter={[8, 8]}
                style={{
                    display: 'flex',
                    /* 水平置中 */
                    justifyContent: 'left',
                    /* 垂直置中 */
                    // alignItems: 'center' 
                }}
            >
                <Col>
                    <Typography.Title level={3}>
                        個人資料維護
                    </Typography.Title>
                </Col>
                <Col span={24} >
                    <StaffForm
                        edit={true}
                        mode={"full"}
                        /* 欄位標籤前置位置 */
                        propsForm={form}
                        /* 是否為parent物件控制form */
                        formReloadCount={formReloadCount}
                        /* 強制刷新的變數 */
                        onFormFinish={onFormFinish}
                    /* 送出表單後的事件 */
                    />

                </Col>
                <Col span={24} >
                    <Row gutter={[8, 8]}
                        style={{
                            display: 'flex',
                            alignContent: 'center',
                            justifyContent: 'center'
                        }}>
                        <Col>
                            <Button>清除</Button>
                        </Col>
                        <Col>
                            <Button loading={modalLoading} onClick={() => form.submit()}>送出</Button>
                        </Col>
                    </Row>
                </Col>
            </Row>
        </>
    );
};
export default Home;